import { signOut } from 'aws-amplify/auth'
import { basename } from './config'

export const logoutAndRedirect = async (
  options: {
    clearCacheSharePassword?: ()=> void
  } = {}
) => {
  await signOut()
  options.clearCacheSharePassword?.()
  window.location.replace(`${basename}login`)
}
